import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ManagementBase from '../../legacyCMS/management/ManagementBase';
import Loader from '../../legacyCMS/components/Loader';

export const LegacyEhubManagment = () => {
  const { logged } = useSelector(state => state.authReducer);
  const loadingReducer = useSelector(state => {
    return Object.entries(state)
      .filter(key => {
        if (key[1].loading)
          return key;
        return null
      });
  })

  return (
    <>
      {
        !logged ?
          <Redirect to={`/login/ehub`} />
          :
          <>
            {/* LOADING SCREEN  */}
            {
              (loadingReducer.length > 0) ?
                <Loader isLoading={loadingReducer[0][1]} /> : ""
            }
            <ManagementBase />
          </>
      }
    </>
  )
}
